import {
  RESET_GET_KYC_DETAILS,
  GET_KYC_DETAILS_SUCCESS,
  GET_KYC_DETAILS_FAILED,
  GET_KYC_DETAILS_LOADING,
  GET_KYC_DETAILS_INVALID_REQUEST
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: "",
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_KYC_DETAILS_LOADING:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        networkError: "",
        data: {}
      };
    case GET_KYC_DETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        networkError: "",
        data: action.payload
      };
    case GET_KYC_DETAILS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        networkError: "",
        data: action.payload
      };
    case GET_KYC_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload
      };

    // case NETWORK_ERROR_UPGRADE_WALLET:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     failed: false,
    //     success: false,
    //     invalidRequest: false,
    //     networkError: "Something went wrong.."
    //   };

    case RESET_GET_KYC_DETAILS:
      return (state = initialState);

    default:
      return state;
  }
};
